import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import TestimonialSection from './components/TestimonialSection';
import FaqSection from './components/FaqSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <HeroSection />
      <CategorySection />
      <FeaturedSection />
      <TestimonialSection />
      <FaqSection />
      <NewsletterSection />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'asmr1',
            url: 'https://asmr1.com',
            description: 'asmr1 是您探索沉浸式ASMR音频世界的首选平台入口。发现最优质的触发音频合集与放松助眠体验。',
            inLanguage: 'zh-Hans',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://asmr1.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'asmr1',
            url: 'https://asmr1.com',
            description: 'asmr1 是您探索沉浸式ASMR音频世界的首选平台入口。',
            foundingDate: '2024',
            contactPoint: {
              '@type': 'ContactPoint',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'asmr1 官方落地页 | 沉浸式ASMR体验入口',
            description: 'asmr1 是您探索沉浸式ASMR音频世界的首选平台入口。在这里发现最优质的asmr1内容资源、触发音频合集与放松助眠体验。',
            url: 'https://asmr1.com',
            inLanguage: 'zh-Hans',
            isPartOf: { '@type': 'WebSite', name: 'asmr1', url: 'https://asmr1.com' },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              { '@type': 'Question', name: 'asmr1是什么？', acceptedAnswer: { '@type': 'Answer', text: 'asmr1是一个专注于沉浸式ASMR音频体验的平台，我们精心挑选和制作各类ASMR触发音、助眠音频、减压冥想等内容，为用户提供高品质的听觉享受和放松体验。' } },
              { '@type': 'Question', name: 'ASMR对所有人都有效吗？', acceptedAnswer: { '@type': 'Answer', text: '每个人对ASMR的敏感度和触发类型偏好不同。有的人对敲击音特别敏感，有的人更喜欢人声耳语。建议多尝试asmr1的不同分类内容，找到最适合自己的类型。' } },
              { '@type': 'Question', name: '听ASMR需要什么设备？', acceptedAnswer: { '@type': 'Answer', text: '为了获得最佳的沉浸式体验，我们推荐使用高品质的入耳式或头戴式耳机。asmr1的所有音频都支持双声道立体声播放。' } },
              { '@type': 'Question', name: 'ASMR音频可以帮助治疗失眠吗？', acceptedAnswer: { '@type': 'Answer', text: '大量用户反馈表明，定期收听ASMR助眠音频可以显著改善入睡困难的问题。如果您有严重的睡眠障碍，建议同时咨询专业医生。' } },
              { '@type': 'Question', name: 'asmr1的内容会定期更新吗？', acceptedAnswer: { '@type': 'Answer', text: '是的！我们的内容团队每周都会更新新的ASMR音频内容，涵盖触发音合集、助眠放松、减压冥想等多个分类。' } },
              { '@type': 'Question', name: '如何判断哪种ASMR类型适合我？', acceptedAnswer: { '@type': 'Answer', text: '我们建议从触发音合集和自然白噪音两个分类开始尝试，这两个分类覆盖面广，触发效果普遍较好。' } },
            ],
          }),
        }}
      />
    </>
  );
}